module.exports = __webpack_public_path__ + "img/sp2.98b4d8cb.svg";